import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Html5Qrcode } from 'html5-qrcode';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ArrowLeft, Camera, QrCode } from 'lucide-react';

export default function EmployeeScanWoPage() {
  const navigate = useNavigate();
  const [scanning, setScanning] = useState(false);
  const [error, setError] = useState(null);
  const scannerRef = useRef(null);

  const startScanner = async () => {
    setError(null);
    setScanning(true);
    try {
      const html5QrCode = new Html5Qrcode("qr-reader");
      scannerRef.current = html5QrCode;
      await html5QrCode.start(
        { facingMode: "environment" },
        { fps: 10, qrbox: { width: 250, height: 250 } },
        (decodedText) => {
          // Extract work order ID from URL like /wo-clock?id=XXX
          let woId = null;
          try {
            const url = new URL(decodedText);
            woId = url.searchParams.get('id');
          } catch {
            // Maybe it's just the ID directly
            if (decodedText.length > 10 && decodedText.includes('-')) {
              woId = decodedText;
            }
          }
          if (woId) {
            html5QrCode.stop().catch(() => {});
            navigate(`/wo-clock?id=${woId}`);
          }
        },
        () => {} // ignore scan failures
      );
    } catch (err) {
      setError("Impossible d'acceder a la camera. Verifiez les permissions.");
      setScanning(false);
    }
  };

  useEffect(() => {
    return () => {
      if (scannerRef.current) {
        scannerRef.current.stop().catch(() => {});
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-slate-900 flex flex-col items-center justify-center p-4">
      <div className="w-full max-w-sm space-y-5">
        <Button
          variant="ghost"
          className="text-slate-400 hover:text-white"
          onClick={() => navigate('/employee/dashboard')}
          data-testid="scan-back-btn"
        >
          <ArrowLeft className="w-4 h-4 mr-2" /> Retour
        </Button>

        <div className="text-center space-y-2">
          <QrCode className="w-12 h-12 text-cyan-400 mx-auto" />
          <h1 className="text-xl font-bold text-white">Scanner une fiche</h1>
          <p className="text-slate-400 text-sm">Scannez le QR code sur la fiche de travail imprimee pour timbrer sur le vehicule.</p>
        </div>

        <Card className="overflow-hidden rounded-2xl bg-slate-800 border-slate-700">
          <div id="qr-reader" className="w-full" style={{ minHeight: scanning ? 300 : 0 }} />
          {!scanning && (
            <div className="p-8 flex flex-col items-center gap-4">
              <Camera className="w-16 h-16 text-slate-600" />
              <Button
                onClick={startScanner}
                className="bg-cyan-600 hover:bg-cyan-700 text-white font-bold rounded-xl px-8 py-3"
                data-testid="start-scan-btn"
              >
                <Camera className="w-5 h-5 mr-2" />
                Ouvrir la camera
              </Button>
            </div>
          )}
        </Card>

        {error && (
          <div className="text-center text-red-400 text-sm bg-red-500/10 rounded-xl p-3">
            {error}
          </div>
        )}
      </div>
    </div>
  );
}
